import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import axios from 'axios';
import DashboardLayout from '../../DashboardLayout';
import Button from '../../../../components/UI/Button/Button';
import { deleteMyProfile } from '../../../../redux/features/deleteProfileSlice';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const DeleteMyProfile = () => {
  const dispatch = useDispatch();
  const {
    deleteMyProfileError,
    deleteMyProfileLoading,
    deleteMyProfileSuccess,
  } = useSelector((state) => state.deleteProfile);

  const [reason, setReason] = useState('');
  const [comment, setComment] = useState('');
  // const [loading, setLoading] = useState(false);
  // const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(
      deleteMyProfile({
        reason,
        comment,
      })
    );
    // }

    // if (!reason) {
    //   setMessage('⚠️ Please select a reason.');
    //   return;
    // }

    // try {
    //   setLoading(true);
    //   setMessage('');
    //   const token = localStorage.getItem('auth_token');
    //   const response = await axios.post(
    //     `${BACKEND_URL}/api/delete-my-profile`,
    //     {
    //       reason,
    //       comment,
    //     },
    //     {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //       },
    //     }
    //   );

    //   if (response.data?.status === 'success') {
    //     setMessage('✅ Your profile has been deleted successfully.');
    //   } else {
    //     setMessage('❌ Failed to delete profile. Please try again.');
    //   }
    // } catch (error) {
    //   console.error('Delete profile error:', error);
    //   setMessage('❌ Something went wrong.');
    // } finally {
    //   setLoading(false);
    // }
  };

  return (
    <DashboardLayout activePage='deleteMyProifle'>
      <div className='flex flex-col justify-start items-start w-full'>
        <h2 className='text-2xl font-bold text-[#FF4061] mb-4'>
          Delete My Profile
        </h2>

        {deleteMyProfileSuccess && (
          <div className='mb-4 p-3 w-full rounded-md text-center bg-green-100 text-green-600'>
            ✅ Your delete profile request has been sent successfully.
          </div>
        )}

        {deleteMyProfileError && (
          <div className='mb-4 p-3 w-full rounded-md text-center bg-red-100 text-red-600'>
            ❌ {deleteMyProfileError}
          </div>
        )}

        <form
          onSubmit={handleSubmit}
          className='flex flex-col justify-start items-start w-full border-2 border-[#FFC0CB] rounded-lg p-6 bg-white'
        >
          {/* Reason Dropdown */}
          <label className='font-semibold mb-2'>Reason</label>
          <select
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className='w-full border rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-[#FF4061]'
          >
            <option value=''>-- Select Reason --</option>
            <option value='No Need of this profile any more'>
              No Need of this profile any more
            </option>
            <option value='Got Married'>Got Married</option>
            <option value='Created Mistakenly'>Created Mistakenly</option>
          </select>

          {/* Comment Box */}
          <label className='font-semibold mb-2'>
            Comment (please write your reason in description box)
          </label>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows='5'
            placeholder='Write your reason...'
            className='w-full border rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-[#FF4061]'
          />

          {/* Submit Button */}
          <div className='flex justify-center items-center w-full mt-8'>
            {/* <Link to='/findprofile' className='flex justify-center items-center'> */}
            <Button
              text='Submit'
              className='h-[50px] w-full md:w-[200px] font-bold'
              // onButtonClick={handleOnFindYourMatch}
            >
              {deleteMyProfileLoading && (
                <div className='flex justify-center items-center bg-white rounded-full ml-2'>
                  <svg
                    className='animate-spin h-6 w-6 text-pink-500'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                  >
                    <circle
                      className='opacity-25'
                      cx='12'
                      cy='12'
                      r='10'
                      stroke='currentColor'
                      strokeWidth='4'
                    ></circle>
                    <path
                      className='opacity-75'
                      fill='currentColor'
                      d='M4 12a8 8 0 018-8v8H4z'
                    ></path>
                  </svg>
                </div>
              )}
            </Button>
            {/* </Link> */}
          </div>
          {/* <button
            type='submit'
            disabled={loading}
            className='bg-[#FF4061] text-white px-6 py-2 rounded-md font-semibold hover:bg-[#e03550] transition disabled:opacity-50'
          >
            {loading ? 'Deleting...' : 'Submit'}
          </button> */}
        </form>
      </div>
    </DashboardLayout>
  );
};

export default DeleteMyProfile;
